import React, { useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import { Quote } from '../../../ui/Typography';
import { theme } from '../../../Theme';
import SectionWrapper from '../../../Layout/SectionWrapper';
import Image from '../components/Image';
import { Below } from '@jetshop/ui/Breakpoints';

const ArticleHeroWrapper = styled(SectionWrapper)`
  width: 100%;
  padding: 20px 0;
  margin: 0 auto;
`;

const ContentWrapper = styled('div')`
  gap: 48px;
  padding: 84px 0 28px 0;
  text-align: center;
`;

const ImageWrapper = styled('div')`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
`;

const Title = styled(Quote)`
  max-width: 90%;
  margin-bottom: 1.5rem;
  font-weight: 325;
  font-size: 2.5rem;

  ${theme.below.sm} {
    font-size: 1.7rem;
  }
`;

const DateAndCategoryWrapper = styled('div')`
  font-size: 14px;
  display: flex;
  justify-content: center;
  gap: 0.5rem;

  a {
    text-decoration: none; /* Remove default underline */
    color: inherit; /* Inherit color from parent */
    transition: text-decoration 0.2s ease; /* Smooth transition for underline */
  }

  a:hover {
    text-decoration: underline; /* Add underline on hover */
  }
`;

const Separator = styled('span')`
  margin: 0 0.25rem;
`;

const ArticleHero = ({ title, media, date, category, locale }) => {
  const [currentPath, setCurrentPath] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentPath(window.location.pathname);
    }
  }, []);

  const formattedDate = date
    ? new Date(date).toLocaleDateString('en-CA').replace(/-/g, '/')
    : null;

  const formatCategoryForUrl = category => {
    return category ? category.toLowerCase().replace(/\s+/g, '-') : '';
  };

  const newPath = currentPath
    ? currentPath.substring(0, currentPath.lastIndexOf('/') + 1)
    : '';

  return (
    <ArticleHeroWrapper>
      {title && (
        <ContentWrapper>
          <Title className="overlay text-shadow">{title}</Title>
          <DateAndCategoryWrapper>
            {category && (
              <a href={`${newPath}?c=${formatCategoryForUrl(category)}`}>
                <span>{category}</span>
              </a>
            )}
            {date && category && <Separator>•</Separator>}
            {formattedDate && <span>{formattedDate}</span>}
          </DateAndCategoryWrapper>
        </ContentWrapper>
      )}
      <ImageWrapper>
        <Below breakpoint="sm">
          {matches => (
            <Image
              fillAvailableSpace={true}
              src={media?.filename}
              alt={media?.alt || title || 'Article Image'}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }}
            />
          )}
        </Below>
      </ImageWrapper>
    </ArticleHeroWrapper>
  );
};

export default ArticleHero;
